function cov_1pa8whsf3a() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/FavoriteFilled.tsx";
  var hash = "f26dbe0089c12788f7eb9ee050e92a3da1745f1a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/FavoriteFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 55
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f26dbe0089c12788f7eb9ee050e92a3da1745f1a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1pa8whsf3a = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1pa8whsf3a();
var Icon = (cov_1pa8whsf3a().s[0]++, {
  name: 'favorite-filled',
  svg: "<path xmlns=\"http://www.w3.org/2000/svg\" d=\"M11.9904 21.5596C11.7763 21.5596 11.5612 21.5211 11.3452 21.4442C11.1291 21.3672 10.9391 21.2467 10.775 21.0826L9.33848 19.7769C7.56539 18.1602 5.98238 16.5721 4.58943 15.0125C3.19648 13.4528 2.5 11.782 2.5 9.99998C2.5 8.58076 2.97852 7.39263 3.93558 6.43558C4.89263 5.47853 6.08076 5 7.49998 5C8.30638 5 9.10285 5.1859 9.8894 5.5577C10.6759 5.9295 11.3795 6.53335 12 7.36925C12.6205 6.53335 13.324 5.9295 14.1105 5.5577C14.8971 5.1859 15.6936 5 16.5 5C17.9192 5 19.1073 5.47853 20.0644 6.43558C21.0214 7.39263 21.5 8.58076 21.5 9.99998C21.5 11.8012 20.7916 13.4907 19.375 15.0682C17.9583 16.6458 16.3788 18.2205 14.6365 19.7923L13.2154 21.0826C13.0513 21.2467 12.8596 21.3672 12.6404 21.4442C12.4211 21.5211 12.2045 21.5596 11.9904 21.5596Z\" fill=\"currentColor\"/>"
});
export default Icon;